import Button from '@mui/material/Button';
import { useSignOut } from '../auth/useSignOut';
import { COPY } from '../copy';

/** Sign out; `loading` disables it while logout is in flight (ACT-008, FRM-014). Sign-out always
 *  ends in a full navigation, so `busy` is never reset. On the app bar it takes `color="inherit"`:
 *  the brand guarantees only appBarInk on appBar there (CNPWKS-0007). */
export function SignOutButton({
  variant = 'outlined',
  color = 'primary',
}: {
  variant?: 'outlined' | 'contained';
  color?: 'primary' | 'inherit';
}) {
  const { busy, run } = useSignOut();

  return (
    <Button variant={variant} color={color} loading={busy} onClick={run}>
      {COPY.signOut}
    </Button>
  );
}
